import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall,
  getBranches,
  getEmployes,
  getRoles,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
class UserDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: [],
      roles: [],
      branches: [],
      loading: false,
      isLoad: true,
      formData: {
        id: '',
        name: '',
        surname: '',
        email: '',
        phone: '',
        status: 1,
        branch_id: '',
        role: '',
        password: '',
        password_confirmation: ''
      }
    }
  }
  async componentDidMount() {
    this.getUserInfo();
    const roles = await getRoles();
    const branches = await getBranches();
    this.setState({ roles: roles, branches: branches });
  }
  setEmployees = async () => {
    const employees = await getEmployes();
    localStorage.setItem('employees', JSON.stringify(employees));
  }
  getUserInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall('business/user/get-info-by-id/' + id, 'get', null);
      this.setState({ user: response });
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        if (key === 'role') {
          updatedData[key] = response['roles'][0].name;
        } else {
          updatedData[key] = response[key] === undefined ? "" : response[key]
        }

      })

      this.setState({ formData: updatedData }, () => {
        this.setState({ isLoad: false })
      });
    } catch (e) {
      this.setState({ isLoad: false })
    }
  }
  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const key = name;

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [key]: type === 'radio' ? (checked ? parseInt(value) : 0) : value
      }
    }));
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { formData } = this.state;
    const userFormData = new FormData();
    Object.keys(formData).forEach(key => {
      userFormData.append(key, formData[key]);
    });
    try {
      const response = await apiCall('business/user/update/' + formData.id, 'post', userFormData);
      mainHelper.toastMessage(response.status, response.message)
      this.setState({ loading: false });

    } catch (e) {
      this.setState({ loading: false });
    }

  }
  render() {
    const { user, loading, roles, branches } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateUserPermission = userPermissions.includes('update user');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Kullanıcı detayları"
              Breadcrumb={[
                { name: "Kullanıcılar", navigate: "users" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="body">

                    <div className="media">
                      <div className="media-left m-r-15">
                        <img
                          alt="User"
                          className="user-photo media-object"
                          src={user && (user.profile_photo_url)}
                        />
                      </div>
                    </div>
                  </div>
                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <h6>Temel Bilgiler</h6>
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              id="name"
                              name="name"
                              className="form-control"
                              placeholder="Ad"
                              type="text"
                              value={this.state.formData.name}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <input
                              id="surname"
                              name="surname"
                              className="form-control"
                              placeholder="Soyad"
                              type="text"
                              value={this.state.formData.surname}
                              onChange={this.handleChange}
                            />
                          </div>
                          <h6>Şifre Değiştir</h6>

                          <div className="form-group">
                            <input
                              id="password"
                              name="password"
                              className="form-control"
                              placeholder="Yeni şifre"
                              type="password"
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <input
                              id="password_confirmation"
                              name="password_confirmation"
                              className="form-control"
                              placeholder="Yeni şifre tekrar"
                              type="password"
                              onChange={this.handleChange}
                            />
                          </div>

                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <select id="role" name="role" className="form-control" value={this.state.formData.role}
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {roles.map(item => (
                                <option key={item.id} value={item.name}>{item.name.split('_')[0]}</option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group">
                            <select id='branch_id' name='branch_id' className="form-control" value={user.branch_id}
                              onChange={this.handleChange}>
                              <option value="">Şube Seçiniz</option>
                              {branches.map(item => (
                                <option key={item.id} value={item.id}>{item.name}</option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group">
                            <input
                              id="email"
                              name="email"
                              className="form-control"
                              placeholder="Email"
                              type="email"
                              value={this.state.formData.email}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <input
                              id="phone"
                              name="phone"
                              className="form-control"
                              placeholder="Telefon"
                              type="text"
                              value={this.state.formData.phone}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <div>
                              <label className="fancy-radio">
                                <input
                                  name="status"
                                  id="active"
                                  type="radio"
                                  value="1"
                                  checked={this.state.formData.status === 1}
                                  onChange={this.handleChange}
                                />
                                <span><i></i>Aktif</span>
                              </label>
                              <label className="fancy-radio">
                                <input
                                  name="status"
                                  id="passive"
                                  type="radio"
                                  value="0"
                                  checked={this.state.formData.status === 0}
                                  onChange={this.handleChange}
                                />
                                <span><i></i>Pasif</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="body">
                        <div className="row clearfix justify-content-center">
                          <div className="col-lg-6 col-md-12">
                            {loading ? (
                              <button className="btn btn-outline-primary btn-block"
                                disabled={true}
                                style={{ textAlign: "-webkit-center" }}>
                                Lütfen Bekleyin...<ReactLoading type="spin"
                                  width={'24px'}
                                  height={'24px'}
                                  color="#268bd2"></ReactLoading>
                              </button>
                            ) :
                              <button disabled={!userHasUpdateUserPermission}
                                className="btn btn-outline-primary btn-block"
                                type="submit">
                                Güncelle
                              </button>}

                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(UserDetail)));
